import { render, staticRenderFns } from "./WalletPending.vue?vue&type=template&id=930d0cf0&"
import script from "./WalletPending.vue?vue&type=script&lang=js&"
export * from "./WalletPending.vue?vue&type=script&lang=js&"
import style0 from "./WalletPending.vue?vue&type=style&index=0&id=930d0cf0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports